/* globals jQuery:true, ajaxurl:true, wf_sn_cs:true */
/* globals: dialog_id */
/*
* Security Ninja - Scheduled Scanner add-on
* (c) 2014. Web factory Ltd
*/

jQuery( document ).ready( function( $ ) {
  
  
  // get the updates
  get_latest_update();
  
  
  
  /**
  * fixDialogClose.
  *
  * @author	Lars Koudal
  * @since	v0.0.1
  * @version	v1.0.0	Friday, December 18th, 2020.
  * @global
  * @param	mixed	event	
  * @return	void
  */
  function fixDialogClose( event ) {
    jQuery('.ui-widget-overlay').bind('click', function(){ jQuery('#' + event.target.id).dialog('close'); });
  }
  
  
  /**
  * renderSource.
  *
  * @author	Lars Koudal
  * @since	v0.0.1
  * @version	v1.0.0	Friday, December 18th, 2020.
  * @global
  * @param	mixed	event	
  * @return	void
  */
  function renderSource( event ) {
    var dialog_id = '#' + event.target.id;
    
    jQuery.post(ajaxurl, {
      action: 'sn_core_get_file_source',
      filename: jQuery('#source-dialog').dialog('option', 'file_path'),
      hash: jQuery('#source-dialog').dialog('option', 'file_hash'),
      _ajax_nonce: wf_sn_cs.nonce
      
    }, function(response) {
      if (response) {
        if (response.err) {
          jQuery(dialog_id).html('<p><b>An error occured.</b> ' + response.err + '</p>'); // @i8n
        } else {
          jQuery(dialog_id).html('<pre class="sn-core-source"></pre>');
          jQuery('pre', dialog_id).text(response.source);
          jQuery('pre', dialog_id).snippet(response.ext, {style: 'whitengrey'});
        }
      } else {
        alert('An undocumented error occured. The page will reload.'); // @i8n
        window.location.reload();
      }
    }, 'json');
  }
  
  
  
  

  $('button.sn-show-source').on("click",function() {
    $($(this).attr('href')).dialog('option', {
      title: 'File source: ' + $(this).attr('data-file'), // @i8n
      file_path: $(this).attr('data-file'),
      file_hash: $(this).attr('data-hash')
    }).dialog('open');
    return false;
  });
  
  
  
  // Restore a file
  $(document).on('click', 'button.sn-restore-source', function(e) {
    e.preventDefault();
    if (!confirm('Are you sure you want to restore this file?')) { // @i8n
      return false;
    }
    jQuery(this).attr('disabled', 'disabled');
    var filename = jQuery(this).attr('data-file');
    var filehash = jQuery(this).attr('data-hash');
    jQuery.post(ajaxurl, {
      action      : 'sn_core_restore_file_do',
      _ajax_nonce : wf_sn_cs.nonce,
      filename: filename,
      filehash: filehash
    }, function(response) {
      if (response == '1') {
        jQuery('[data-hash="'+filehash+'"]').closest('li').fadeOut( "slow", function() {
          jQuery(this).remove();
        });
      } 
      else {
        alert('An error occured - ' + response); // @i8n
        jQuery(this).attr('disabled', '');
      }
    }, 'json');
    
  });
  
  
  
  // Delete a file
  $(document).on('click', 'button.sn-delete-source', function(e) {
    e.preventDefault();
    if (!confirm('Are you sure you want to delete this file?')) { // @i8n
      return false;
    }
    jQuery(this).attr('disabled', 'disabled');
    var filename = jQuery(this).attr('data-file');
    var filehash = jQuery(this).attr('data-hash');
    jQuery.post(ajaxurl, {
      action      : 'sn_core_delete_file_do',
      _ajax_nonce : wf_sn_cs.nonce,
      filename: filename,
      filehash: filehash
    }, function(response) {
      if ( response.success ) {
        jQuery('[data-hash="'+filehash+'"]').closest('li').fadeOut( "slow", function() {
          jQuery(this).remove();
        });
      } 
      else {
        alert('An error occured - ' + response); // @i8n
        jQuery(this).attr('disabled', '');
      }
    }, 'json');
  });
  


  
  
  // Delete ALL files
  $(document).on('click', 'button.sn-delete-all-files', function(e) {
    e.preventDefault();
    if (!confirm('Are you sure you want to delete all unknown files?')) { // @i8n
      return false;
    }
    jQuery(this).attr('disabled', 'disabled');

    jQuery.ajax({
      url: ajaxurl, // WP variable, contains URL pointing to admin-ajax.php
      type: 'POST',
      data: {
      'action'      : 'sn_core_delete_all_unknowns',
      '_ajax_nonce' : wf_sn_cs.delete_all_nonce
    },
    success: function(  ) {
      window.location.reload();
    },
    error: function(  ) {
      // Whooops, something went wrong!
    }
  });
});
  
  $('#source-dialog').dialog(
    {
      'dialogClass': 'wp-dialog',
      'modal': true,
      'resizable': false,
      'zIndex': 9999,
      'width': 800,
      'height': 550,
      'hide': 'fade',
      'open': function(event, ui) { renderSource(event, ui); fixDialogClose(event, ui); },
      'close': function() { jQuery('#source-dialog').html('<p>Please wait.</p>'); }, // @i8n
      'show': 'fade',
      'autoOpen': false,
      'closeOnEscape': true
    }
    );
    
    
    /**
    * get_latest_update.
    *
    * @author	Lars Koudal
    * @since	v0.0.1
    * @version	v1.0.0	Wednesday, December 30th, 2020.
    * @global
    * @param	mixed	forceupdate	
    * @return	void
    */
    function get_latest_update( forceupdate ) {

      jQuery( '#wf-sn-core-scanner-response' ).show();

      jQuery( '#wf-sn-core-scanner-response #sn-cs-results' ).slideUp();
      jQuery( '#wf-sn-core-scanner-response #last_scan').slideUp();
      jQuery( '#wf-sn-core-scanner-response .spinner' ).addClass( 'is-active' );
      var data = {
        action: 'sn_core_run_scan',
        _ajax_nonce: wf_sn_cs.nonce
      };
      if (forceupdate) {
        data.doupdate = true;
      }
      $.post( ajaxurl, data, function( response ) {
        jQuery( '#wf-sn-core-scanner-response .spinner' ).removeClass( 'is-active' );

        if ( response.data.out ) {
          jQuery( '#wf-sn-core-scanner-response' ).append( response.data.out ).slideDown();
        }
        if ( response.data.last_scan ) {
          jQuery('#wf-sn-core-scanner-response #last_scan').html( response.data.last_scan ).slideDown();
        }
      }, 'json');
    }
    
    
    
    
    // Run AJAX core scan and display returned results
    $( document ).on( 'click', '#sn-run-core-scan', function( e ) {
      e.preventDefault();
      jQuery( '#wf-sn-core-scanner-response #sn-cs-results' ).slideUp();
      jQuery( '#wf-sn-core-scanner-response #last_scan').slideUp();
      jQuery( '#wf-sn-core-scanner-response .spinner' ).addClass( 'is-active' );
      jQuery.post(ajaxurl, {
        action: 'sn_core_run_scan',
        _ajax_nonce: wf_sn_cs.nonce,
        datatype: 'json',
        doupdate: true
      }, function( response ) {
        jQuery( '#wf-sn-core-scanner-response .spinner' ).removeClass( 'is-active' );
        if ( response.data.out ) {
          jQuery( '#wf-sn-core-scanner-response' ).append( response.data.out ).slideDown();
        }
        if ( response.data.last_scan ) {
          jQuery('#wf-sn-core-scanner-response #last_scan').html( response.data.last_scan ).slideDown();
        }
      });
    } );
  });